import { Route, Routes } from 'react-router-dom'
import React, { Component, useState } from 'react'

import NewPlayer from './pages/Player'
import { DEFAULT_PATH, VIDEO_PATH } from './configs/router-config'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback
    }

    return this.props.children
  }
}

const App = () => {
  const [video, setVideo] = useState(null)

  return (
    <ErrorBoundary
      fallback={
        <video width="100%" src={video?.url} crossOrigin="anonymous" controls>
          {video?.subtitlesEnabled === 'vtt' && (
            <track
              srcLang={video.subtitlesLanguage}
              default={true}
              kind="subtitles"
              src={video.subtitlesUrl}
              label={video.subtitlesLanguage}
            />
          )}
          Your browser doesn't&apost support video player
        </video>
      }
    >
      <Routes>
        <Route path={VIDEO_PATH} element={<NewPlayer video={video} setVideo={setVideo} />} />
        <Route path={DEFAULT_PATH} element={<NewPlayer video={video} setVideo={setVideo} />}></Route>
      </Routes>
    </ErrorBoundary>
  )
}

export default App
